import { apiClient } from "./client";
import type { MembershipKindInOrg, OrganizationKind, SlotKind } from "./types";

// Single source of truth is ./types — re-exported so existing consumers that
// import it from "@/api/roster" keep working.
export type { OrganizationKind };

export type RosterGroup = {
  id: string;
  code: string;
  name: string;
  kind: OrganizationKind;
  color: string | null;
  operates_weekends?: boolean;
  operates_holidays?: boolean;
  excludes_bridge_days?: boolean;
  operating_hours_start?: string | null;
  operating_hours_end?: string | null;
  closed_dates?: string[];
};

export type RosterCell = {
  organization_id: string;
  slot_template_id: string;
  slot_label: string;
  slot_kind: SlotKind;
  start_time: string;
  end_time: string;
  is_overnight: boolean;
  target_headcount: number;
  practitioner_id: string | null;
  practitioner_name: string | null;
  first_initial: string | null;
  membership_kind: MembershipKindInOrg | null;
  fte_percent: number | null;
};

export type RosterDay = {
  date: string;
  cells: RosterCell[];
};

export type RosterResponse = {
  from_date: string;
  to_date: string;
  groups: RosterGroup[];
  days: RosterDay[];
};

export async function getRoster(
  from: string,
  to: string,
  organizationIds?: string[],
): Promise<RosterResponse> {
  const params = new URLSearchParams({ from, to });
  if (organizationIds) {
    for (const id of organizationIds) params.append("organization_ids", id);
  }
  const { data } = await apiClient.get<RosterResponse>(
    `/api/v1/roster?${params.toString()}`,
  );
  return data;
}

export async function downloadRosterCsv(
  from: string,
  to: string,
  organizationIds?: string[],
): Promise<Blob> {
  const params = new URLSearchParams({ from, to });
  if (organizationIds) {
    for (const id of organizationIds) params.append("organization_ids", id);
  }
  const { data } = await apiClient.get<Blob>(
    `/api/v1/roster/csv?${params.toString()}`,
    { responseType: "blob" },
  );
  return data;
}
